import { ArrowRight } from 'lucide-react';

type Props = {
  title?: string;
  desc?: string;
  email?: string;
};

export default function LegalContactV2({
  title = 'Une question juridique précise ?',
  desc = "On te répond en moins de 72h ouvrées. Pour les requêtes RGPD/OHADA, inclus l'objet « Droit RGPD » ou « OHADA » dans ton email.",
  email = 'contact@velko-pos.com',
}: Props) {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="flex flex-wrap items-center justify-between gap-6 border-[3px] border-charcoal-800 bg-paper p-8 shadow-neobrutal-8 md:p-10">
          <div className="max-w-[52ch]">
            <h3 className="font-marketing-display text-[22px] font-bold tracking-[-0.02em] text-charcoal-800">
              {title}
            </h3>
            <p className="mt-2 font-marketing-body text-[14px] leading-[1.6] text-charcoal-600">
              {desc}
            </p>
          </div>
          <a
            href={`mailto:${email}`}
            className="inline-flex items-center gap-2 border-2 border-charcoal-800 bg-lime-500 px-6 py-3.5 font-marketing-display text-[14px] font-bold text-charcoal-800 shadow-neobrutal-3 transition-transform duration-150 hover:-translate-x-[2px] hover:-translate-y-[2px] hover:shadow-neobrutal-5"
          >
            {email}
            <ArrowRight className="h-[14px] w-[14px]" strokeWidth={2.5} />
          </a>
        </div>
      </div>
    </section>
  );
}
